module.exports = __webpack_public_path__ + "media/images/icons/expand-left-1f57924683d0aa9bfd2b8ed642ee2ea0.svg";